import React from 'react';
import { Button } from '@mui/material';

const BetaAccessMessage = () => (
  <div>
    <h4>Book a demo</h4>
    <p className="auth-subtitle">
      Book a demo with our team to learn more about our AI-powered platform, get a personalized
      tour, and ask any questions you may have.
    </p>
    <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
      <Button
        variant="outlined"
        color="inherit"
        onClick={() => (window.location.href = '/')}
        style={{ borderRadius: 8 }}
      >
        Back
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          window.open(
            'https://form.workflow86.com/form/57c15fd2-87b4-45cc-8700-7a7da8607f09',
            '_blank'
          )
        }
        style={{ borderRadius: 8 }}
      >
        Book a demo
      </Button>
    </div>
  </div>
);

const SignUpSuccessMessage = ({ email }) => (
  <div>
    <h4>Check your email</h4>
    <p className="auth-subtitle">We've sent instructions to {email}</p>
  </div>
);

const ReferralMessage = () => <h4>Invite code</h4>;

const SignUpHeader = () => (
  <div>
    <h4>Create an account</h4>
    <p className="auth-subtitle">Get started with Workflow86 for free</p>
  </div>
);

const ConditionalSignupMessage = ({ allowNewSignups, formState, email }) => (
  <>
    {!allowNewSignups ? (
      <BetaAccessMessage />
    ) : formState === 'signUpSuccess' ? (
      <SignUpSuccessMessage email={email} />
    ) : formState === 'referral' ? (
      <ReferralMessage />
    ) : (
      <SignUpHeader />
    )}
  </>
);

export default ConditionalSignupMessage;
